import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const HACCPChart6 = ({ jmlHaccp }) => {
  const data = jmlHaccp?.data;

  const chartData = useMemo(() => {
    if (!data) return null;

    const A = Number(data.A ?? 0);
    const B = Number(data.B ?? 0);
    const C = Number(data.C ?? 0);

    const total = A + B + C;
    if (total === 0) return null;

    return {
      series: [A, B, C],
      total,

      options: {
        chart: {
          type: "donut",
          toolbar: { show: false },
        },

        labels: ["Grade A", "Grade B", "Grade C"],

        colors: ["#008FFB", "#00E396", "#FEB019"],

        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
          style: {
            fontSize: "11px",
            fontWeight: 600,
            colors: ["#ffffff"],
          },
        },

        plotOptions: {
          pie: {
            donut: {
              size: "60%", // ✅ BAR LEBIH TEBAL
            },
          },
        },

        legend: {
          position: "bottom",
          fontSize: "12px",
        },

        stroke: {
          width: 0,
        },
      },
    };
  }, [data]);

  if (!chartData) return null;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: 260,
      }}
    >
      {/* DONUT */}
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="donut"
        height={260}
      />

      {/* TEKS TENGAH */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -120%)", // ✅ CENTER PAS
          textAlign: "center",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: "#6c757d",
            marginBottom: 4,
            letterSpacing: 0.5,
          }}
        >
          JUMLAH
        </div>

        <div
          style={{
            fontSize: 24,
            fontWeight: 700,
            color: "#212529",
            lineHeight: 1,
          }}
        >
          {chartData.total.toLocaleString("id-ID")}
        </div>
      </div>
    </div>
  );
};

export default HACCPChart6;
